import React, {} from "react";
import DashboardMainCards from "../../../src/screens/AttendenceScreen/DashboardMainCards";
import {assets} from "../../../src/assets/assets";
import {useSelector} from "react-redux";

import {NavLink} from "react-router-dom";
import DashboardFieldCard from "../../../src/screens/AttendenceScreen/DashboardFieldCard";

export default function DashboardScreen() {
    const {userInfo} = useSelector((state: any) => state.auth)

    if (!userInfo) {
        return <NavLink to={"/login"}>Login</NavLink>
    }

    return (
        <main className={"min-h-screen bg-slate-50 p-6 sm:p-6 lg:p-8"}>
            <NavLink to={"/"} className={"py-4 px-2 flex items-center hover:text-gray-700"}>
                <img
                    src={assets.k_Solution_logo}
                    alt="K Solution"
                    className="w-[120px] sm:w-[120px] rounded-md shadow-2xl"
                />
            </NavLink>

            <div className={"mx-auto max-w-6xl"}>
                <h2 className={"text-xl font-bold text-slate-900 sm: text-2xl"}>
                    Select Area To Get Started
                </h2>

              <div className={"mx-auto py-6 gap-y-2"}>

                  { userInfo.isAdmin === true ? (
                          <DashboardMainCards />
                  ) : (
                          <DashboardFieldCard />
                  )}

              </div>

            </div>
        </main>
    )
}